// extracted by mini-css-extract-plugin
module.exports = {"addButton":"teamCommon_addButton__3HgxV"};